import { Module } from "../../components/module/module";

export const ModulePage = () => {
  return <Module />;
};
